module.exports = __webpack_public_path__ + "img/icon_guo.d6973c0e.jpg";